export class TranslatorConverter{
    translateDistrictTransferStatus(value:number){
        switch(value){
            case -1: return "رد شده";
            case 0: return "انتظار";
            case 1: return "تایید شده";
            default:return "نامشخص";
        }

    }
    translateDistrictBenefitType(value:number){
        switch(value){
            case 1: return "فروش";
            case 2: return "مرجوعی";
            case 3: return "کنسلی";
            case 4: return "نامشخص";
            default:return "نامشخص";
        }

    }
    translateDistrictBenefitCalculationType(value:number){
        switch(value){
            case 1: return "2%";
            case 2: return "بالابود ۵۰٪";
            default:return "نامشخص";
        }

    }
    translateCustomerRequestState(value: any) {
        switch(value){
            case 1: return "در انتظار";
            case 2: return "تایید شده";
            case 3: return "رد شده";
            default:return "نامشخص";
        }
    }
    public translateAccountType(v:number){
        switch(v){
            case 1: return "حساب جاری";
            case 2: return "پس انداز";
            case 3: return "قرض الحسنه";
            default:return "نامشخص";
        }
    }
    public PurchaseProcessStateNameConverter(v:number){
        switch(v){
            case 1: return "ّInquiry";
            case 2: return "Quotation";
            case 4: return "PreOrder";
            case 8: return "Proforma";
            case 16: return "PurchaseOrder";
            case 32: return "Invoice";
            case 64: return "Return";
            case 4096: return "Receipt";
            default:return "نامشخص";
        }
    }
    public translateProductRequestState(v:number){
        switch(v){
            case 1: return "در انتظار";
            case 2: return "تایید شده";
            case 3: return "رد شده";
            default:return "نامشخص";
        }
    }
    public translateInvoiceState(v:number){
        switch(v){
            case 0: return "در انتظار تایید";
            case 1: return "تایید شده";
            case 2: return "تکمیل";
            case 3: return "لغو شده";
            default:return "نامشخص";
        }
    }
    public translateInvoiceDeliveryWarehouseState(v:number){
        switch(v){
            case 0: return "جدید";
            case 1: return "تایید شده";
            case 2: return "جمع آوری شده";
            case 3: return "آماده برای تحویل";
            case 4: return "تحویل داده شده";
            case 5: return "لغو شده";
            default:return "نامشخص";
        }
    }
    public translateInvoicePaymentState(v:number){
        switch(v){
            case 0: return "پرداخت نشده";
            case 1: return "در حال پرداخت";
            case 2: return "در حال پرداخت در محل";
            case 3: return "پرداخت در محل تکمیل شده";
            case 4: return "پرداخت شده";
            case 5: return "لغو شده";
            default:return "نامشخص";
        }
    }
    public translateInvoiceShippingWarehouseState(v:number){
        switch(v){
            case 0: return "جدید";
            case 1: return "تایید شده";
            case 2: return "اضافه شده به لیست";
            case 3: return "ارسال شده";
            case 4: return "دریافت شده";
            case 5: return "لغو شده";
            default:return "نامشخص";
        }
    }
    public translateInvoiceType(v:number){
        switch(v){
            case 1: return "فروش";
            case 2: return "مرجوعی فروش";
            case 3: return "خرید";
            case 4: return "مرجوعی خرید";
            default:return "نامشخص";
        }
    }
    public translateSendPackageState(v:number){
        switch(v){
            case 0: return "جدید";
            case 1: return "ارسال شده";
            case 2: return "دریافت شده";
            case 3: return "لغو شده";
            default:return "نامشخص";
        }
    }
    public translateInternalTransferType(v:number){
        switch(v){
            case 0: return "کد به کد";
            case 1: return "انبار به انبار";
            default:return "نامشخص";
        }
    }
    public translateInternalTransferStatus(v:number){
        switch(v){
            case 0: return " ";
            case 1: return "تعیین نشده";
            case 2: return "تایید شده";
            case 3: return "رد شده";
            default:return "نامشخص";
        }
    }
    public translateReturnInvoiceReasonType(v:number){
        switch(v){
            case 1:return "انصراف از خريد توسط مشتري تسويه  کرده";
            case 2:return "برگشت با هماهنگي آقاي باقري";
            case 3:return "شکستگي قطعه";
            case 4:return "خط وخش دار بودن قطعه";
            case 5:return "به دلیل مشکوک بودن جنس به جهت عملکردی و برندی قابل تحویل نیست.";
            case 6:return "اشتباه شماره فني از طرف کاربر";
            case 7:return "اشتباه شماره فني از طرف مشتري";
            case 8:return "فرو رفتگي قطعه";
            case 9:return "مغاير بودن قطعه با شماره فني ليبل";
            case 10:return "به ادعاي مشتري کالا اصلي نمي باشد";
            case 11:return "اشتباه در ثبت کاربر";
            case 12:return "اشتباه در ثبت معادل سازي سيستم";
            case 13:return "پيدا نشدن قطعه در انبار بازار";
            case 14:return "پيدا نشدن قطعه در انبار پرند";
            case 15:return "انصراف از خريد توسط مشتري تسويه نکرده";
            case 16:return "اشتباه در تحويل شماره فني ونوع کالا";
            case 17:return "اشتباه در تعيين انبار توسط کاربر";
            case 18:return "مشکل سيستمي بدليل تکرار فاکتور";
            case 19:return "تسويه نکردن مشتري";
            case 20:return "اشتباه تعداد در شماره فني";
            case 21:return "قطعه معيوب ارسال شده از پرند";
            case 22:return "ارسال اشتباه قطعه از پرند";
            case 23:return "اشتباه در ثبت برند قطعه توسط کاربر";
            case 24:return "اشتباه در تحويل برند کالا";
            case 25:return "ارسال نشدن قطعه از انبار پرند";
            default:return "نامشخص";
        }
    }
    
    payableReceivableConverter(v: number) {
        switch(v){
            case 1:return 'پرداخت';
            case 2:return 'دریافت';
            default:return '';
        }    
    }
    methodConverter(v: number) {
        switch(v){
            case 1:return 'فروش';
            case 2:return 'مرجوعی';
            case 3:return 'خرید';
            case 4:return 'مرجوعی خرید';
            case 5:return 'پوز';
            case 6:return 'کارت به کارت';
            case 7:return 'کنسلی فروش';
            case 8:return 'شبا';
            case 9:return 'نقد';
            case 10:return 'انتقال وجه';
            case 12:return 'چک';
            case 13:return 'تسهیلات';
            default:return '';
        }    
    }
    arapTransactionStatusConverter(v: number) {
        switch(v){
            case 1:return 'در انتظار تایید';
            case 2:return 'تایید شده';
            case 3:return 'رد شده';
            default:return '';
        }    
    }
    public paymentProcessTypeNameConverter(v:number):string{
        switch(v){
            case 1:return 'پیش پرداخت';
            case 2:return 'علی الحساب';
            case 3:return 'تسویه حساب';
            default:return '';
        }
    }
    public transactionTransferTypeNameConverter(v:number):string{
        switch(v){
            case 1:return 'نقد';
            case 2:return 'پوز';
            case 3:return 'کارت به کارت';
            case 4:return 'انتقال وجه';
            case 5:return 'چک';
            case 6:return 'برداشت';
            case 7:return 'آنلاین';
            case 8:return 'شبا';
            default:return '';
        }
    }
    public paymentProcessStateNameConverter(v:number):string{
        switch(v){
            case 1:return 'در انتظار دستور';
            case 2:return 'در انتظار مجوز';
            case 3:return 'دارای مجوز';
            case 4:return 'پرداخت شده';
            default:return '';
        }
    }
    
}